import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/illustrations/email.png'


const _hoisted_1 = { class: "_send-invite _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "150",
    width: "150"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "w-full mt-5"
}
const _hoisted_7 = { class: "input-group flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal w-2/5" }, " Email ", -1)
const _hoisted_9 = {
  key: 0,
  class: "input-group flex items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_11 = { class: "mt-4 w-full" }
const _hoisted_12 = { class: "error text-sienna-600 text-sm w-full" }
const _hoisted_13 = { class: "input-group grid grid-cols-2 items-center mt-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Tên đầy đủ ", -1)
const _hoisted_15 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_16 = { class: "input-group grid grid-cols-2 items-center mt-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Tên hiển thị ", -1)
const _hoisted_18 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_19 = { class: "input-group grid grid-cols-2 items-center mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Chức vụ ", -1)
const _hoisted_21 = { class: "flex items-center justify-end" }
const _hoisted_22 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.invited ? 'Gửi liên kết thành công' : 'Gửi liên kết '), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.invited
						? `Luca đã gửi lời mời liên kết tài khoản tới email của người dùng.
                           Bạn hãy nhắc họ kiểm tra email và làm theo hướng dẫn để bắt đầu sử dụng Luca nhé`
						: `Bạn hãy điền email của người dùng để Luca gửi liên kết giúp họ đăng nhập và sử dụng Luca dưới cơ sở của bạn nhé`), 1),
      (!_ctx.invitedValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Email của người dùng tài khoản này",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            (_ctx.errorMes['email'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, " Địa chỉ email '" + _toDisplayString(_ctx.email) + "' " + _toDisplayString(_ctx.errorMes['email']), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.staff.full_name), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.staff.name), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.role(_ctx.staff.role)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString(_ctx.invited ? 'Đóng' : 'Thoát'), 1),
      (!_ctx.invitedValue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["button-p text-center whitespace-nowrap", _ctx.isEmailValid ? '' : 'btn--none-active']),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.inProgress
          }, " Xác nhận ", 10, _hoisted_23))
        : _createCommentVNode("", true)
    ])
  ]))
}